import React, { FC, useState } from 'react';
import { Input } from 'antd';
import { Button } from 'Components';
import useLogin from '../Hooks/LoginHooks';
import styles from './TenantLogin.module.scss';
import { ReactComponent as EyeOpen } from '../../../../Icons/new-eye-oppened.svg';
import { ReactComponent as EyeCross } from '../../../../Icons/new-eye-crossed.svg';

interface TenantLoginProps {
	setShowResetPassModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const TenantLogin: FC<TenantLoginProps> = ({ setShowResetPassModal }) => {
	const formik = useLogin();
	const [showPass, setShowPass] = useState(false);

	const viewPass = () => setShowPass(true);
	const hidePass = () => setShowPass(false);

	const forgotPassword = () => setShowResetPassModal(true);

	const ErrorComponent = (
		<div className={styles.errorMsg}>
			<strong>Invalid username or password.</strong> Try again, reset your
			password, or contact your manager.
		</div>
	);

	return (
		<div className={styles.container}>
			<div className={styles.title}>Sign in</div>

			<form onSubmit={formik.handleSubmit}>
				<div className={styles.field}>
					<label>Username</label>
					<Input
						name="username"
						size="large"
						placeholder="Enter your username"
						className={styles.inputField}
						value={formik.values.username}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
					/>
					{formik.touched.username && formik.errors.username && (
						<div className={styles.errorMsg}>
							{formik.errors.username}
						</div>
					)}
				</div>

				<div className={styles.field}>
					<label>Password</label>
					<Input
						name="password"
						type={showPass ? 'text' : 'password'}
						placeholder="Enter your password"
						className={styles.innerInput}
						suffix={
							showPass ? (
								<EyeCross onClick={hidePass} />
							) : (
								<EyeOpen onClick={viewPass} />
							)
						}
						value={formik.values.password}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
					/>
					{formik.touched.password && formik.errors.password && (
						<div className={styles.errorMsg}>
							{formik.errors.password}
						</div>
					)}
				</div>

				<Button
					type="primary"
					shape="round"
					htmlType="submit"
					loading={formik.isSubmitting}
				>
					Log in
				</Button>
			</form>

			{formik.status && ErrorComponent}

			<div className={styles.forgotPassword} onClick={forgotPassword}>
				Forgot your password?
			</div>
		</div>
	);
};

export default TenantLogin;
